<template>
    <section v-if="connectPop.list" :class="[shit$(connectPop.wrapper)]">
        <section v-if="status === 'connected.seted'">
            <template v-for="(o, i) in connectPop.collapse">
                <control-collapse @interfaceEvent="receiveChildEmit" :data="o" :key="i"></control-collapse>
            </template>
        </section>
        <p v-if="status !== 'quickConnected.normal'" :class="[shit$(connectPop.title.shit)]">{{ connectPop.title.label }}</p>
        <template v-if="status === 'connect'">
            <template v-for="(o, i) in connectPop.list" >
                <div :class="shit$(connectPop.item)" :key="i" @click="() => { 
                    const current = connectPop.handler(connectPop, { current: i })
                    current === 0 ? $store.commit('rmsConnection/switchRmsHandler', true) : $store.commit('quickConnection/switchQuickHandler', true)
                }">{{ o.label }}</div>
            </template>
        </template>
        <template  v-if="status === 'connected.set'">
          <template v-for="(o, i) in connectPop.list">
              <p v-if="isLastIndex(i, connectPop.list)" :class="shit$(`h:1px; bgc:#a8a8ac; my:9px;`)" :key="i + o"></p>
              <div :class="shit$(connectPop.item)" :key="i" @click="() => {
                const current = connectPop.handler(connectPop, { current: i })
                current === 0 ? $store.commit('teachConnection/switchRmsHandler', true) : closeConnect()
              }">{{ o.label }}</div>
          </template>
        </template>
        <template v-if="status === 'quickConnected.normal'">
          <template v-for="(o, i) in connectPop.list" >
              <div :class="shit$(connectPop.item)" :key="i" @click="() => {
                const current = connectPop.handler(connectPop, { current: i })
                current === 0 && closeQuickConnect()
              }">{{ o.label }}</div>
          </template>
          <div :class="[ shit$(`lh:normal; px:12px; pt:7px;`), ]">
            <p :class="shit$(`c:#c8c8c8; font:12px; letter-s:0px;`)">{{ this.$t('versionOldTips.connectRobot') }}{{ webVersionAllow ? this.$t('versionOldTips.connectRobotCodeLab') : `「 ${this.$t('versionOldTips.connectRobotCodeLab')} APP」` }}{{this.$t('versionOldTips.connectRobotVersion')}}</p> 
          </div>
          <div :class="[ shit$(`font:12px; pr:12px;`), shit$(`c:#${ webVersionAllow ? 'c8c8c8' : 'ff2968' };`) ]">
            <p :class="shit$(`dis:f; letter-s:0.69px; justify-c:fe; align-i:c; h:32px;`)">
              <img v-if="!webVersionAllow" :class="shit$(`w:14px; mr:5px;`)" :src="`${env$}static/images/connect/not-allow-version.png`" />
              <span>{{ robotVersionFormat }}</span>
            </p>
            <p v-if="!webVersionAllow" :class="shit$(`pl:12px; lh:normal;`)">{{ this.$t('versionOldTips.connectRobotContext') }}</p>
          </div>

        </template>
        <template v-if="status === 'connected.seted'">
            <section :class="shit$(connectPop.robot.shit)">{{ connectPop.robot.label }}</section>
            <template v-for="(o, i) in connectPop.list" >
                <p v-if="isLastIndex(i, connectPop.list)" :class="shit$(`h:1px; bgc:#a8a8ac; my:6px;`)" :key="i + o"></p>
                <p v-else :class="shit$(`h:1px; bgc:#a8a8ac; mb:6px;`)" :key="i + o"></p>
                <div :class="shit$(connectPop.item)" :key="i" @click="() => {
                  const current = connectPop.handler(connectPop, { current: i })
                  current === 0 ? $store.commit('teachConnection/switchRmsHandler', true) : (robotConnectStore.stopValue && playButtonMutations.allStatus(), closeConnect())
                }">{{ o.label }}</div>
            </template>
        </template>
    </section>
</template>

<script>
import ControlCollapse from "@/code-lab/component/robot-connect/device-manage/control-collapse.vue";
import { store } from "@/code-lab/component/robot-connect/device-manage/observable/store.js";
import { mutations as playButtonMutations } from '@/code-lab/component/robot-connect/play-button/observable.js'
import { store as robotConnectStore } from '@/code-lab/component/robot-connect/robotConnectOber.js'
import { obserState } from '@/code-lab/component/robot-connect/play-button/microstate/playState.js'
import config from '@/service/config.js'
import IndexMixStore from '@/code-lab/component/mixins/indexMixStore.js'
const clsoeConnectAsync = () => import("@/code-lab/component/robot-connect/device-manage/observable/close-connect.js")
import { mapState } from 'vuex'
import Vue from 'vue'
export default {
  mixins: [ IndexMixStore ],
  components: {
    ControlCollapse
  },
  props: {
    status: String
  },
  computed: {
    ...mapState(['currentVersion', 'env$', 'webVersion']),
    inProgressIs () {
      return obserState.inProgressIs
    },
    webVersionAllow () {
      // console.log(this.$store.state.webVersion, this.webVersion, 'this.$store.state.webVersion')
      return this.getWebVersion(config.appVersion, this.webVersion)
    }
  },
  data () {
    return {
      connectPop: {},
      robotVersionFormat: ''
    }
  },
  async beforeCreate () {
    this.playButtonMutations = playButtonMutations
    this.robotConnectStore = robotConnectStore
    Vue.prototype.closeConnect$ = (await clsoeConnectAsync()).closeConnect
  },
  watch: {
    status: {
      immediate: true,
      handler: "statusWather"
    },
    webVersion () {
      if (!this.webVersionAllow) {
        this.showUnsavedTips(7)
      }
      const robotVersion = this.b$.quick.store && this.b$.quick.store.versionConfig.versionCode && this.b$.quick.store.versionConfig.versionCode.toString() || ''
      this.robotVersionFormat = robotVersion.split('.').join('-')
    }
  },
  methods: {
    getWebVersion (vers, vers1) {
      const versArr = vers.split('.').reverse(), vers1Arr = vers1.split('.').reverse()
      let sum = 0, sum1 = 0
      for (let index = 0, len = versArr.length; index < len; index ++) {
          if (versArr[index] > vers1Arr[index]) {
              sum += index + 1
          }

          if (versArr[index] < vers1Arr[index]) {
              sum1 += index + 1
          }
      }
      console.log(sum, sum1, vers, vers1)
      return sum >= sum1
    },
    closeQuickConnect () {
      console.log('clsoe1 ->', this.inProgressIs)
      if (![0, 3].includes(this.inProgressIs)) return
      console.log('clsoe ->', this.inProgressIs)
      this.closeConnect()
    },
    statusWather (status) {
      const connectPop = store.state.pop;
      const state = this.getIndexOf(status, ".") ? status.split(".") : status;
      const res =
        typeof state === "string"
          ? connectPop[state]
          : connectPop[state[0]][state[1]];
      Object.assign(this, { connectPop: res });
    },
    updateDataToConnectPop(obj, { key = "collapse", targetKey = 0 }) {
      if (this.getIndexOf(key, ".")) {
        let arr = key.split(".");
        let trg = arr.reduce((pre, nxt) => pre[nxt], this.connectPop);
        return Object.assign(trg, obj);
      }
      Object.assign(this.connectPop[key][targetKey], obj);
    },
    receiveChildEmit({ targetKey, data, key }) {
      this.updateDataToConnectPop(data, { targetKey, key });
    },
    closeConnect () {
      this.closeConnect$()
    },
    isLastIndex(index, arr) {
      return arr.length - 1 === index;
    },
    getLastChild(arr) {
      return arr.slice(-1)[0];
    },
    getIndexOf(str, find) {
      return str.indexOf(find) > -1;
    }
  }
};
</script>
